import ForgotPassword from "../features/Auth/components/ForgotPassword";

function ForgotPasswordPage() {
    return (
        <ForgotPassword />
    );
}

export default ForgotPasswordPage;